// assets/academy-top.js
(function () {
  function initSlider(slider) {
    var progressWrap = slider.parentElement.querySelector('[data-academy-slider-progress]');
    if (!progressWrap) return;
    var bar = progressWrap.querySelector('.academy-product-grid__progress-bar');
    if (!bar) return;

    function update() {
      var maxScroll = slider.scrollWidth - slider.clientWidth;

      if (maxScroll <= 0) {
        // スクロールする余地がない(アイテム数が少ない等)場合はバー全体を表示
        bar.style.width = '100%';
        bar.style.transform = 'translateX(0)';
        return;
      }

      // 現在何%までスクロールしたか(0〜1)
      var scrolledRatio = slider.scrollLeft / maxScroll;

      // バー自体の幅は「見えている割合」で決める
      var visibleRatio = slider.clientWidth / slider.scrollWidth;
      var barWidthPercent = Math.max(visibleRatio * 100, 10); // 極端に細くなりすぎないよう最低10%を確保

      // トラック(progressWrap)の実ピクセル幅を基準に、バーが動ける実距離をピクセルで計算する。
      // transform: translateX(N%) の % は「バー自身の幅」基準になってしまうため、
      // ここではピクセル値を直接指定して正確な位置に動かす。
      var trackWidthPx = progressWrap.clientWidth;
      var barWidthPx = trackWidthPx * (barWidthPercent / 100);
      var maxOffsetPx = trackWidthPx - barWidthPx;
      var offsetPx = maxOffsetPx * scrolledRatio;

      bar.style.width = barWidthPercent + '%';
      bar.style.transform = 'translateX(' + offsetPx + 'px)';
    }

    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // 初期表示時にも一度計算しておく
    update();
  }

  function initAllSliders() {
    document.querySelectorAll('[data-academy-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }
})();